module.exports = {
    appBundleBaseName: 'atozmyhrfabmanifest',
    appManifestName: 'atozMyHRFABManifest',
    packagingDirName: 'packaging_additional_published_artifacts',
    widgetName: 'atozmyhrfabmanifest',
};
